import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import get from 'lodash/get.js';
import { useMainStore } from './mainStore.js';

export const useAlertBannerStore = defineStore('alertBanner', () => {
  // --- State ---
  const alertBannerConfig = ref({});
  const alertBannerSeparate = ref([]);
  const isAlertModalOpen = ref(false);

  // --- Getters ---
  const getThemeAlertShadowOverlay = computed(() => {
    const mainStore = useMainStore();
    const alertColorHex = get(mainStore.globals, 'info.alert_lightbox_overlay.hex', '#383147');
    return `${alertColorHex}cc`;
  });

  // --- Actions ---
  function setAlertBannerConfig(payload) {
    alertBannerConfig.value = payload;
  }
  function setAlertBannerSeparate(payload) {
    alertBannerSeparate.value = payload;
  }
  function setAlertModalOpen(isOpen) {
    isAlertModalOpen.value = isOpen;
  }

  return {
    alertBannerConfig,
    alertBannerSeparate,
    isAlertModalOpen,
    getThemeAlertShadowOverlay,
    setAlertBannerConfig,
    setAlertBannerSeparate,
    setAlertModalOpen,
  };
});
